module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popup book-details"
  }, [_c('button', {
    on: {
      "click": _vm.closeMe
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('h1', [_vm._v("Details of: " + _vm._s(_vm.book.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.book.imgUrl
    }
  }), _vm._v(" "), _c('h3', [_vm._v("\\$" + _vm._s(_vm.book.price))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.book.author))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.book.desc))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.requestNextBook
    }
  }, [_vm._v("Next > ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-561078a7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/BookDetails.vue
// module id = 285
// module chunks = 1